import { render, staticRenderFns } from "./register-box.vue?vue&type=template&id=f45eabe8&scoped=true&"
import script from "./register-box.vue?vue&type=script&lang=js&"
export * from "./register-box.vue?vue&type=script&lang=js&"
import style0 from "./register-box.vue?vue&type=style&index=0&id=f45eabe8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45eabe8",
  null
  
)

export default component.exports